import { animation } from "./types";

export const animationStyles = {
  [animation.WAVES]: "",
  [animation.PULSE]: "animate-[pulse_2s_infinite_ease-out]",
};
